import router from "@/router";
import { isToufang } from "./base";

export const calcScores = (scores) => {
    return +scores / 10
}

export function getParams() {
    const queryParams = {};
    const queryString = window.location.search.substring(1);
    const params = queryString.split('&');

    params.forEach(param => {
        const [key, value] = param.split('=');
        queryParams[key] = decodeURIComponent(value || '');
    });

    return queryParams;
}

export function getParam(key){
    return getParams()[key];
}

export const setStorage = (key, value) => {
    if(typeof value === "object" && value !== null){
        value = JSON.stringify(value)
    }
    localStorage.setItem(key, value);
}

export const getStorage = (key) => {
    return localStorage.getItem(key)
}

export const removeStorage = (key) => {
    localStorage.removeItem(key)
}

export const clearStorage = () => {
    localStorage.clear();
}

export const calcPrice = (price) => {
    const value = Number(price) || 0
    return (value / 100).toFixed(2).replace(/\.00$/, '')
}

export const loadScript = (src, successCallback = () => {}, failCallback = () => {}, attrs = {}) => {
    const scriptId = attrs.id
    const existing = scriptId ? document.getElementById(scriptId) : null

    if (existing) {
        successCallback(existing)
        return existing
    }

    const script = document.createElement('script')
    script.src = src
    script.async = true

    Object.keys(attrs || {}).forEach((key) => {
        script.setAttribute(key, attrs[key])
    })

    script.onload = () => successCallback(script)
    script.onerror = failCallback
    document.body.appendChild(script)
    return script
}

export const isFacebookWebView = () => {
  const ua = window.navigator.userAgent;
  return /FB_IAB|FBAN|FBAV|FBWEBVIEW|FBANLITE/i.test(ua);
};

export const isAndroid = () => {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    return isAndroid;
}

export const isIos = () => {
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return isiOS;
}

export const goToRouter = (path, query = {}) => {
    const obj = {}
    if(isFacebookWebView() || getParam('ch')){
        obj.ch = '1'
    }
    router.app.$router.push({
        path,
        query: {
            ...query,
            ...obj
        }
    })
}
